import helpers from './helpers'

export const setupAxios = (axios, auth, store) => {
  axios.interceptors.response.use(null, helpers.error(auth, store))
  axios.interceptors.request.use(helpers.injecttoken(auth, store))
}
